import React, { useEffect, useState } from 'react'
import Fixtures from '../../components/Fixtures/Fixtures'
import News from '../../components/News/News'
import Series from '../../components/Series/Series'
import HeroBanner from '../../components/HeroBanner/HeroBanner'
import { useDispatch } from 'react-redux'
import { homeData } from '../../features/home/homeSlice'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import Skeleton from '../../components/Skeleton/Skeleton'




const Home = () => {
  const [firstRender, setfirstRender] = useState(false)


  // useEffect(() => {
  
  //     const userAgent = navigator.userAgent || window.opera;
  
  //   // Check if the user is on a mobile device
  //   if (!firstRender && /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
  //     // Replace 'myAppPackageName' with your actual Android package name
  //     const androidPackageName = 'com.cricway.app';
  //     // Replace 'com.cricway.app' with your actual iOS app ID
  //     const iOSAppId = 'com.cricway.app';
  
  //     // Replace 'myAppPAckage://' with your actual app's custom URL scheme
  //     const appScheme = 'cricway.live://';
  
  //     // Attempt to open the app using the custom URL scheme
  //     const appOpenTimeout = setTimeout(() => {
  //       // Redirect to the app store if the app doesn't open within a certain time
  //       const userChoice = window.confirm('Would you like to download our mobile app for a better experience?');
  
  //       if (userChoice) {
  //         // Redirect to App Store for iOS
  //         if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
  //           window.location.href = `https://apps.apple.com/app/id${iOSAppId}`;
  //         }
  //         // Redirect to Google Play Store for Android
  //         else if (/android/g.test(navigator.userAgent)) {
  //           window.open(`https://play.google.com/store/apps/details?id=${androidPackageName}`, '_blank');
  //         }
  //       }
  //     }, 2000); // Adjust the timeout duration as needed
  
  //     window.location.href = appScheme;
  
  //     // Clear the timeout if the app opens successfully
  //     window.addEventListener('pagehide', () => {
  //       clearTimeout(appOpenTimeout);

  //     });
  //     setfirstRender(true);
  //   }

   
    
    
  // }, [firstRender]);
  

  // useEffect(() => {
  //   const userAgent = navigator.userAgent  || window.opera;

  //   // Check if the user is on a mobile device
  //   if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
  //     // Replace 'your-app-scheme://' with your actual app's custom URL scheme
  //     const appScheme = 'cricway.live://';

  //     // Attempt to open the app using the custom URL scheme
  //     window.location.href = appScheme;

  //     // Set a timeout to show the download popup if the app is not opened
  //     setTimeout(() => {
  //       // Replace 'your-ios-app-id' with your actual iOS app ID
  //       const iOSAppId = 'com.cricway.app';
  //       const appStoreUrl = `https://apps.apple.com/app/id${iOSAppId}`;

  //       // Replace 'your-android-package-name' with your actual Android package name
  //       const androidPackageName = 'com.cricway.app';
  //       const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidPackageName}`;

  //       const userChoice = window.confirm(
  //         'Would you like to download our mobile app for a better experience?'
  //       );

  //       if (userChoice) {
  //         // Redirect to App Store for iOS
  //         if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
  //           window.location.href = appStoreUrl;
  //         }
  //         // Redirect to Google Play Store for Android
  //         else if (/android/g.test(navigator.userAgent)) {
  //           window.location.href = playStoreUrl;
  //         }
  //       }
  //     }, 2000); // Adjust the timeout duration as needed
  //   }
  // }, []);

  return (
    <>
    {/* <Series /> */}
    <Fixtures />
    <HeroBanner />
    {/* <Skeleton /> */}
    
    <Series />
    <News />
    {/* <Footer /> */}

      
    </>
  )
}

export default Home
